import React, { Component } from "react";
import { Alert } from "reactstrap";
import CmsContent from "../../../MiddleWare/CmsContent";
import Datatable from "../../../components/Datatable/Datatable";
import FormMiddleWare from "../../../components/Form/FormMiddleware";
import { confirmAlert } from "react-confirm-alert";
import TableExample from '../../../components/PDF/TableExample';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { CSVLink, CSVDownload } from "react-csv";

class Domain extends FormMiddleWare {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      editvalue: "",
      editid: null,
      disableValue: false,
      addNewSubgroup: false,
      error: null,
      button: "Submit",
      index: null,
      alertVisible: false,
      alertVisible1: false,
      formAlertdelete: false,
      textview: null,
      color: "success"
    };
  }
  async componentDidMount() {
    let userlog = localStorage.getItem("userlog");
    userlog = JSON.parse(userlog);


    let companyid = userlog.id;
    this.setState({ companyid });
    try {
      // const result = await CmsContent.getSingleConditionedValue(
      //   "tbl_domain",
      //   "companyid",
      //   companyid
      // );

      const result = await CmsContent.getFreedom("*",
        "tbl_domain",
        `companyid =${companyid}`, 1, 1)
      console.log(result);
      if (result) {

        // this.setState({ data: result.data });
      }
      if (result.data.length > 0) {
        const header = [
          'SI.NO',
          'DOMAIN'
        ];
        const excelHead = [
          { label: "Domain", key: "name" }
        ];


        this.setState({
          header,
          excelHead,
          data: result.data,
          title: "DOMAIN"
        });
      }


    } catch (error) {
      console.log(error);
    }
  }
  column = [
    {
      Header: "Domain",
      accessor: "name"
    },
    {
      Header: "Edit",
      accessor: "edit",
      Cell: (d, modalWindowId) =>
        this.dataTableButton("warning", "Edit", () => {
          this.buttonEdit(d, modalWindowId);
        })
    },
    {
      Header: "Delete",
      accessor: "delete",
      Cell: d =>
        this.dataTableButton("danger", "Delete", () => {
          this.buttonDeletes(d.original);
        })
    }
  ];

  buttonEdit = value => {


    let values = value.original;

    let editid = values.id;
    let editvalue = values.name;
    let data = this.state.data;

    this.setState({
      data,
      index: value.index,
      editvalue: values.name,
      editid: values.id,
      error: null,
      button: "Update"
    });
  };
  buttonDeletes = value => {

    this.setState({});
    confirmAlert({
      title: "Confirmation to Delete",
      message: "Are you sure you want to delete this?",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.buttonDelete(value)
          //onClick: () => alert("Group removed from")
        },
        {
          label: "No"
        }
      ]
    });
  };
  buttonDelete = async value => {
    //Getting Previous state data

    const previousData = [...this.state.data];


    let id = value.id;
    console.log(id)

    try {
      const result = await CmsContent.getSingleConditionedValue(
        "tbl_domain",
        "id",
        id,
        "Delete"
      );
      if (result) {

        let datas = previousData.filter((delelteid, i) => {

          if (delelteid.id !== value.id) {
            return delelteid;
          }
        });
        this.setState({
          data: datas,
          formAlertdelete: true,
          alertVisible: true,
          textview: " Selected Domain Deleted",
          color: "danger"
        });
        setTimeout(() => this.setState({ alertVisible: false }), 3000);
      }
    } catch (error) {
      console.log(error);
    }
  };
  getValueFromArrays = (d, array) => {

    if (array.length > 0) {
      if (array.length !== 0) {
        let filtered = array.filter(function (item) {

          return item.id == d;
        });
        let v = filtered[0];
        if (v != undefined) {

          return v.name;
        } else {
          return "---";
        }
      }
    } else {
      return "-";
    }
  };
  // delete = d => {
  //   let value = d.original.value;
  //   return (
  //     <button type="button" className="btn btn-danger" onClick={() => this.deletion(value)}>
  //       Delete
  //     </button>
  //   );
  // };
  // deletion = async value => {
  //   //Getting Previous state data
  //   const previousData = [...this.state.data];
  //   // Seperating data row using row-index
  //   const getData = { ...previousData[value.index] };

  //   //getting id on that data
  //   const id = getData.value;
  //   //removing specific id in previous state data
  //   const data = previousData.filter(delelteid => delelteid.value !== value);

  //   try {
  //     const result = await cmsContent.deleteMaster('tbl_domain', value);
  //     if (result) {
  //       this.setState({ editvalue: '', formAlertdelete: true, data });

  //       setTimeout(() => this.setState({ formAlertdelete: false }), 3000);
  //     }
  //     const {editvalue}=this.state;
  //     if(editvalue === ''){
  //       this.setState({error:''});
  //     }
  //   } catch (error) {
  //     this.setState({ data: previousData });
  //     console.log(error);
  //   }
  // };
  handlechange = e => {
    let value = e.target.value;

    this.setState({ editvalue: value });
  };
  addnew = async () => {
    const { editvalue: value, companyid } = this.state;
    if (value === null || value.trim() === "") {
      this.setState({ error: "Please Fill Domain" });
      return false;
    }
    let groupArray = {};
    groupArray.name = value.trim();
    groupArray.companyid = companyid;
    groupArray.status = "active";


    try {
      this.setState({ disableValue: true });
      const result = await CmsContent.addMaster("tbl_domain", groupArray);

      if (result) {
        let valueArray = {};
        valueArray.id = result.data.insertId;
        valueArray.name = groupArray.name;
        const newData = [valueArray, ...this.state.data];
        this.setState({
          data: newData,
          alertVisible: true,
          editvalue: "",
          editid: null,
          disableValue: false,
          addNewSubgroup: false,
          error: null,
          button: "Submit",
          index: null,
          textview: "New Domain Added"
        });
        setTimeout(() => this.setState({ alertVisible: false }), 3000);
      }
    } catch (error) {
      console.log(error);
    }
  };
  update = async () => {
    //let value = this.state.editvalue;

    const { editvalue: value, data } = this.state;
    if (value === "") {
      this.setState({ error: "Value Cannot Be Empty" });
      return false;
    } else {
      this.setState({ disableValue: true });
      try {
        let previousdata = [...this.state.data];
        //let index = this.state.index;
        //let id = this.state.editid;

        const { index, editid: id } = this.state;

        let subgroupArray = {};
        subgroupArray.name = value;
        subgroupArray.status = "active";

        const result = await CmsContent.updateMaster(
          "tbl_domain",
          id,
          subgroupArray
        );
        if (result) {
          previousdata[index].id = id;

          previousdata[index].name = value;
          setTimeout(() => {
            this.setState({ data: previousdata, alertVisible1: false });
          }, 500);
        }
      } catch (error) {
        console.log(error);
      }
      this.setState({
        alertVisible: true,
        editvalue: "",
        editid: null,
        addNewSubgroup: false,
        error: null,
        button: "Submit",
        index: null,
        disableValue: false,
        textview: "Updated Sucessfully",
        color: "success"
      });
      setTimeout(() => this.setState({ alertVisible: false }), 3000);
    }
  };
  onDismiss = () => {
    this.setState({ alertVisible: false });
    // this.setState({ alertVisible1: false });
    // this.setState({ formAlertdelete: false });
  };
  render() {

    const {
      editvalue,
      disableValue,
      error,
      button,
      alertVisible,
      alertVisible1,
      formAlertdelete,
      textview,
      color
    } = this.state;
    return (
      <React.Fragment>
        <main className="main my-4">
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-header">
                    <h1>Domain Master</h1>
                  </div>
                  <div className="card-body">
                    <div className="row form-group">
                      <div className="col-sm-2" />
                      <div className="col-sm-7">
                        <Alert
                          className="badge-content"
                          color={color}
                          isOpen={alertVisible}
                          toggle={this.onDismiss}
                        >
                          {/* New Domain Added */}
                          {textview}
                        </Alert>
                        {/* <Alert
                          className="badge-content"
                          color="success"
                          isOpen={alertVisible1}
                          toggle={this.onDismiss}
                        >
                          New Domain Updated
                        </Alert> */}
                        {/* <Alert
                          className="badge-content"
                          color="danger"
                          isOpen={formAlertdelete}
                          toggle={this.onDismiss}
                        >
                          Domain Deleted
                        </Alert> */}
                      </div>
                      <div className="col-sm-3" />
                    </div>
                    <div className="row form-group">
                      <div className="col-sm-2" />
                      <div className="col-sm-2">
                        <label htmlFor="subgroup">Domain</label>
                      </div>
                      <div className="col-sm-5">
                        <input
                          type="text"
                          name="subgroup"
                          placeholder="Enter Domain"
                          className="form-control"
                          value={editvalue}
                          onChange={e => this.handlechange(e)}
                        />
                        <span className="error-shows">{error}</span>
                      </div>
                      <div className="col-sm-3" />
                    </div>
                    <div className="row form-group">
                      <div className="col-sm-2" />
                      <div className="col-sm-2" />
                      <div className="col-sm-5">
                        <button
                          type="button"
                          className="btn btn-primary"
                          disabled={disableValue}
                          onClick={
                            button === "Update" ? this.update : this.addnew
                          }
                        >
                          {this.state.button}
                        </button>
                      </div>
                      <div className="col-sm-3" />
                    </div>

                    {this.state.data && this.state.data.length > 0 && (
                      <PDFDownloadLink
                        style={{ color: 'white' }}
                        document={<TableExample title={this.state.title} header={this.state.header} data={this.state.data} />}
                        fileName="sample.pdf"
                      >
                        {({ blob, url, loading, error }) =>
                          loading ? 'Loading document...' : 'Download Pdf'
                        }
                        <button className="btn btn-warning">
                          PDF
                    </button>
                      </PDFDownloadLink>
                    )}
                    {this.state.data && this.state.data.length > 0 && (
                      <CSVLink data={this.state.data} headers={this.state.excelHead}>
                        <button className="btn btn-success" style={{ marginLeft: '11px' }}>
                          Excel
                    </button>
                      </CSVLink>
                    )}
                    <div style={{ marginTop: '5px' }}> </div>
                    <span>
                      Total of {Object.keys(this.state.data).length} records
                    </span>
                    {this.state.data && (
                      <Datatable
                        data={this.state.data}
                        columnHeading={this.column}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </React.Fragment>
    );
  }
}

export default Domain;
